"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.split");

require("core-js/modules/web.dom-collections.iterator");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerPDFRenderer = exports.PDFRenderer = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@onviobr/element");

var _files = require("./utils/files");

var _pdfRendererPage = require("./pdf-renderer-page");

var _pdfRendererControls = require("./pdf-renderer-controls");

var _async = require("./utils/async");

var _pdfLib = require("./utils/pdf-lib");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n      <style>\n        :host {\n          position: relative;\n          display: flex;\n          justify-content: center;\n          --rotate: 0deg;\n        }\n\n        .pages {\n          display: flex;\n          flex-direction: row;\n          -ms-overflow-style: none;\n          overflow: auto;\n          width: 100%;\n        }\n        .pages::-webkit-scrollbar {\n          display: none;\n        }\n\n        .pages-inner {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          width: 100%;\n          overflow: auto;\n        }\n\n        pdf-renderer-page {\n          flex-shrink: 0;\n          transform: rotate(var(--rotate, 0deg));\n        }\n\n        pdf-renderer-controls {\n          bottom: 19px;\n          position: absolute;\n        }\n      </style>\n      <div class=\"pages\">\n        <div class=\"pages-inner\">", "</div>\n        ", "\n      </div>\n      ", "\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n      <pdf-renderer-controls\n        current=\"", "\"\n        total=\"", "\"\n        zoom=\"", "\"\n        minZoom=\"", "\"\n        maxZoom=\"", "\"\n        zoomScale=\"", "\"\n        @zoom-in=\"", "\"\n        @zoom-out=\"", "\"\n        @prev-page=\"", "\"\n        @next-page=\"", "\"\n      ></pdf-renderer-controls>\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n      <pdf-renderer-page\n        .page=\"", "\"\n        zoom=\"", "\"\n        ?disableTextLayer=\"", "\"\n        @error=\"", "\"\n      ></pdf-renderer-page>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PDFRenderer = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(PDFRenderer, _BlueElement);

  var _super = (0, _createSuper2.default)(PDFRenderer);

  (0, _createClass2.default)(PDFRenderer, null, [{
    key: "is",
    get: function get() {
      return 'pdf-renderer';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        bookmark: {
          type: String,
          attribute: true,
          reflect: false
        },
        pdf: {
          type: Object,
          attribute: false,
          reflect: false
        },
        documentVerId: {
          type: String,
          attribute: true,
          reflect: true
        },
        zoom: {
          type: Number,
          attribute: true,
          reflect: true
        },
        initialZoom: {
          type: Number,
          attribute: true,
          reflect: true
        },
        minZoom: {
          type: Number,
          attribute: true,
          reflect: true
        },
        maxZoom: {
          type: Number,
          attribute: true,
          reflect: true
        },
        zoomScale: {
          type: Number,
          attribute: true,
          reflect: true
        },
        currentPage: {
          type: Number,
          attribute: true,
          reflect: true
        },
        _pages: {
          type: Array,
          attribute: false,
          reflect: false
        },
        dynamicSection: {
          type: Function,
          attribute: false,
          reflect: false
        },
        disableTextLayer: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        rotate: {
          type: Number,
          attribute: true,
          reflect: true
        },
        password: {
          type: String,
          attribute: false,
          reflect: false
        }
      };
    }
  }]);

  function PDFRenderer() {
    var _context, _context2, _context3, _context4, _context5, _context6, _context7;

    var _this;

    (0, _classCallCheck2.default)(this, PDFRenderer);
    _this = _super.call(this);
    _this.bookmark = void 0;
    _this.pdf = void 0;
    _this.zoom = void 0;
    _this.initialZoom = void 0;
    _this.minZoom = void 0;
    _this.maxZoom = void 0;
    _this.zoomScale = void 0;
    _this.currentPage = void 0;
    _this.outline = void 0;
    _this._pages = void 0;
    _this.frame = void 0;
    _this.disableTextLayer = false;
    _this.pagesIntersectionObserver = void 0;
    _this.rotate = void 0;
    _this.password = void 0;
    _this.bookmark = '';
    _this.zoom = 1;
    _this.minZoom = 0.2;
    _this.maxZoom = 5;
    _this.zoomScale = 0.1;
    _this.currentPage = 1;
    _this._pages = [];
    _this.outline = [];
    _this.rotate = 0;
    _this.password = '';
    _this.fireError = (0, _bind.default)(_context = _this.fireError).call(_context, (0, _assertThisInitialized2.default)(_this));
    _this.zoomIn = (0, _bind.default)(_context2 = _this.zoomIn).call(_context2, (0, _assertThisInitialized2.default)(_this));
    _this.zoomOut = (0, _bind.default)(_context3 = _this.zoomOut).call(_context3, (0, _assertThisInitialized2.default)(_this));
    _this.prevPage = (0, _bind.default)(_context4 = _this.prevPage).call(_context4, (0, _assertThisInitialized2.default)(_this));
    _this.nextPage = (0, _bind.default)(_context5 = _this.nextPage).call(_context5, (0, _assertThisInitialized2.default)(_this));
    _this.onKeydown = (0, _bind.default)(_context6 = _this.onKeydown).call(_context6, (0, _assertThisInitialized2.default)(_this));
    _this.onPageScrollIntersection = (0, _bind.default)(_context7 = _this.onPageScrollIntersection).call(_context7, (0, _assertThisInitialized2.default)(_this));
    _this.frame = (0, _async.frames)();
    return _this;
  }

  (0, _createClass2.default)(PDFRenderer, [{
    key: "fireError",
    value: function fireError(error) {
      this.dispatchEvent(new CustomEvent('error', {
        detail: error
      }));
    }
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      if (this.zoom <= this.maxZoom - this.zoomScale) {
        this.zoom += this.zoomScale;
      }

      this.attachIntersectionObserver();
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      if (this.zoom >= this.minZoom + this.zoomScale) {
        this.zoom -= this.zoomScale;
      }

      this.attachIntersectionObserver();
    }
  }, {
    key: "parsePDF",
    value: function () {
      var _parsePDF = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _context8;

        var src, _src$url$split, _src$url$split2, rawData, data;

        return _regenerator.default.wrap(function _callee$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.cleanup();

                if (!(this.pdf && this.pdf instanceof Blob)) {
                  _context9.next = 8;
                  break;
                }

                _context9.next = 4;
                return (0, _files.readFile)(this.pdf);

              case 4:
                this.pdfContent = _context9.sent;
                src = typeof this.pdfContent === 'string' ? {
                  url: this.pdfContent,
                  password: this.password
                } : {
                  data: this.pdfContent,
                  password: this.password
                };
                _context9.next = 9;
                break;

              case 8:
                src = {
                  url: this.pdf,
                  password: this.password
                };

              case 9:
                if (typeof src.url === 'string' && (0, _startsWith.default)(_context8 = src.url).call(_context8, 'data:')) {
                  _src$url$split = src.url.split(';'), _src$url$split2 = (0, _slicedToArray2.default)(_src$url$split, 2), rawData = _src$url$split2[1];
                  data = (0, _startsWith.default)(rawData).call(rawData, 'base64') ? atob(rawData.substr(7)) : rawData;
                  src = {
                    data: data,
                    password: this.password
                  };
                }

                _context9.next = 12;
                return (0, _pdfLib.getDocument)(src).promise;

              case 12:
                this.document = _context9.sent;
                this.dispatchEvent(new CustomEvent('pdf-load-complete', {
                  detail: this.document
                }));
                _context9.next = 16;
                return this.parsePages();

              case 16:
                void this.requestUpdate();
                this.dispatchEvent(new CustomEvent('after-load-complete'));

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee, this);
      }));

      function parsePDF() {
        return _parsePDF.apply(this, arguments);
      }

      return parsePDF;
    }()
  }, {
    key: "parsePages",
    value: function () {
      var _parsePages = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this2 = this;

        var pages, documentMetaData;
        return _regenerator.default.wrap(function _callee3$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                pages = Array.apply(null, Array(this.document.numPages));
                _context11.next = 3;
                return this.document.getMetadata();

              case 3:
                documentMetaData = _context11.sent;
                return _context11.abrupt("return", _promise.default.all((0, _map.default)(pages).call(pages, /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_, index) {
                    var page;
                    return _regenerator.default.wrap(function _callee2$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _context10.next = 2;
                            return _this2.document.getPage(index + 1);

                          case 2:
                            page = _context10.sent;
                            page.documentFingerprint = _this2.document.fingerprint;
                            page.documentName = documentMetaData.contentDispositionFilename;
                            page.creationDate = documentMetaData.info.CreationDate;
                            page.documentVerId = _this2.documentVerId;
                            return _context10.abrupt("return", _this2._pages.push(page));

                          case 8:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }())));

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee3, this);
      }));

      function parsePages() {
        return _parsePages.apply(this, arguments);
      }

      return parsePages;
    }()
  }, {
    key: "cleanup",
    value: function cleanup() {
      var _context12, _context13;

      this.releasePreviousDocument();
      (0, _forEach.default)(_context12 = this._pages).call(_context12, function (page) {
        return page.cleanup(false);
      });
      (0, _splice.default)(_context13 = this._pages).call(_context13, 0);
      this.removePagesObservers();
      this.zoom = this.initialZoom || 1;
      this.outline = [];
    }
  }, {
    key: "releasePreviousDocument",
    value: function releasePreviousDocument() {
      if (this.document) {
        this.document.cleanup();
        this.document.destroy();
      }
    }
  }, {
    key: "getPagesDOM",
    value: function getPagesDOM() {
      return (this.shadowRoot || this).querySelectorAll("div.pages pdf-renderer-page");
    }
  }, {
    key: "getPageDOM",
    value: function getPageDOM(number) {
      return (this.shadowRoot || this).querySelector("div.pages pdf-renderer-page:nth-child(".concat(number, ")"));
    }
  }, {
    key: "removePagesObservers",
    value: function removePagesObservers() {
      var _this3 = this;

      if (this.pagesIntersectionObserver !== undefined) {
        var pagesElements = this.getPagesDOM();
        (0, _forEach.default)(pagesElements).call(pagesElements, function (n) {
          return _this3.pagesIntersectionObserver.unobserve(n);
        });
        this.pagesIntersectionObserver.disconnect();
        this.pagesIntersectionObserver = undefined;
      }
    }
  }, {
    key: "pageTemplate",
    value: function pageTemplate(page, zoom, disableTextLayer) {
      var _this4 = this;

      return this.html(_templateObject(), page, zoom, disableTextLayer, function (event) {
        return _this4.fireError(event.detail);
      });
    }
  }, {
    key: "jumpToBookmark",
    value: function () {
      var _jumpToBookmark = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(destString) {
        var dest, page, pageViewport, height, pageElement, pageDiv, scrollX, offsetY, scrollY;
        return _regenerator.default.wrap(function _callee4$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.bookmark = '';
                _context14.prev = 1;
                dest = JSON.parse(decodeURIComponent(destString));
                _context14.next = 5;
                return this.document.getPageIndex(dest.ref);

              case 5:
                page = _context14.sent;

                if (!(page < 0 || page + 1 > this._pages.length)) {
                  _context14.next = 8;
                  break;
                }

                return _context14.abrupt("return");

              case 8:
                this.currentPage = page + 1;
                pageViewport = this._pages[page].getViewport({
                  scale: this.zoom
                });
                height = pageViewport.height;
                pageElement = this.getPageDOM(this.currentPage);
                _context14.next = 14;
                return this.frame('scroll');

              case 14:
                pageDiv = this.shadowRoot ? this.shadowRoot.querySelector('div.pages-inner') : null;

                if (pageDiv && pageElement) {
                  scrollX = pageElement.offsetLeft + dest.x * this.zoom || 0;
                  offsetY = height - this.zoom * dest.y;
                  scrollY = pageElement.offsetTop + (dest.y ? offsetY : 0);
                  pageDiv.scrollTo(scrollX, scrollY);
                }

                _context14.next = 21;
                break;

              case 18:
                _context14.prev = 18;
                _context14.t0 = _context14["catch"](1);
                this.fireError(_context14.t0);

              case 21:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee4, this, [[1, 18]]);
      }));

      function jumpToBookmark(_x3) {
        return _jumpToBookmark.apply(this, arguments);
      }

      return jumpToBookmark;
    }()
  }, {
    key: "scrollToPage",
    value: function () {
      var _scrollToPage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(page) {
        var pageElement;
        return _regenerator.default.wrap(function _callee5$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(page < 1 || page > this._pages.length)) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return");

              case 2:
                this.currentPage = page;
                pageElement = this.getPageDOM(this.currentPage);
                _context15.next = 6;
                return this.frame('scroll');

              case 6:
                if (pageElement) {
                  pageElement.scrollIntoView({
                    behavior: 'smooth'
                  });
                }

              case 7:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee5, this);
      }));

      function scrollToPage(_x4) {
        return _scrollToPage.apply(this, arguments);
      }

      return scrollToPage;
    }()
  }, {
    key: "prevPage",
    value: function prevPage() {
      void this.scrollToPage(this.currentPage - 1);
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      void this.scrollToPage(this.currentPage + 1);
    }
  }, {
    key: "controlsTemplate",
    value: function controlsTemplate(zoom, currentPage, _pages, zoomOptions) {
      return this.html(_templateObject2(), currentPage, _pages.length, zoom, zoomOptions.minZoom, zoomOptions.maxZoom, zoomOptions.zoomScale, this.zoomIn, this.zoomOut, this.prevPage, this.nextPage);
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      if ((event.metaKey || event.ctrlKey) && event.key === 'ArrowDown') {
        void this.scrollToPage(this._pages.length);
      } else if ((event.metaKey || event.ctrlKey) && event.key === 'ArrowUp') {
        void this.scrollToPage(1);
      } else if (event.key === 'ArrowUp') {
        this.prevPage();
      } else if (event.key === 'ArrowDown') {
        this.nextPage();
      }
    }
  }, {
    key: "onPageScrollIntersection",
    value: function onPageScrollIntersection(entries) {
      var _context16;

      var _entries = (0, _slicedToArray2.default)(entries, 1),
          page = _entries[0];

      if (!page.target.parentElement) {
        return;
      }

      var newPage = (0, _indexOf.default)(_context16 = (0, _from.default)(page.target.parentElement.children)).call(_context16, page.target) + 1;

      if (page.isIntersecting) {
        this.currentPage = newPage;
      }
    }
  }, {
    key: "attachIntersectionObserver",
    value: function attachIntersectionObserver() {
      var _this5 = this;

      this.removePagesObservers();
      var margin = 40 * (this.zoom < 1 ? this.zoom : 1);
      var pageWrapperElement = (this.shadowRoot || this).querySelector("div.pages");

      if (pageWrapperElement && !this.pagesIntersectionObserver) {
        var _context17;

        this.pagesIntersectionObserver = new IntersectionObserver(this.onPageScrollIntersection, {
          root: pageWrapperElement,
          rootMargin: (0, _concat.default)(_context17 = "-".concat(margin, "% 0px -")).call(_context17, margin, "%")
        });
      }

      if (this.pagesIntersectionObserver) {
        var pagesElements = this.getPagesDOM();
        (0, _forEach.default)(pagesElements).call(pagesElements, function (n) {
          return _this5.pagesIntersectionObserver.observe(n);
        });
      }
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(changedProps) {
      if (changedProps.has('rotate')) {
        (this.shadowRoot && this.shadowRoot.host || this).style.setProperty('--rotate', "".concat(this.rotate, "deg"));
      }

      return true;
    }
  }, {
    key: "updated",
    value: function updated(changedProps) {
      void this._onUpdated(changedProps);
    }
  }, {
    key: "_onUpdated",
    value: function () {
      var _onUpdated2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(changedProps) {
        var pdfChanged, bookmarkChanged;
        return _regenerator.default.wrap(function _callee6$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                pdfChanged = changedProps.has('pdf') && this.pdf !== undefined && this.pdf !== changedProps.get('pdf');

                if (!pdfChanged) {
                  _context18.next = 11;
                  break;
                }

                _context18.prev = 2;
                _context18.next = 5;
                return this.parsePDF();

              case 5:
                this.attachIntersectionObserver();
                _context18.next = 11;
                break;

              case 8:
                _context18.prev = 8;
                _context18.t0 = _context18["catch"](2);
                this.fireError(_context18.t0);

              case 11:
                bookmarkChanged = changedProps.has('bookmark') && Boolean(this.bookmark);

                if (bookmarkChanged) {
                  void this.jumpToBookmark(this.bookmark);
                }

              case 13:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee6, this, [[2, 8]]);
      }));

      function _onUpdated(_x5) {
        return _onUpdated2.apply(this, arguments);
      }

      return _onUpdated;
    }()
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _document;

      (0, _get2.default)((0, _getPrototypeOf2.default)(PDFRenderer.prototype), "connectedCallback", this).call(this);
      this.zoom = this.initialZoom || this.zoom;
      (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('keydown', this.onKeydown, false);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _document2;

      (0, _get2.default)((0, _getPrototypeOf2.default)(PDFRenderer.prototype), "disconnectedCallback", this).call(this);
      (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.removeEventListener('keydown', this.onKeydown);
      this.cleanup();
    }
  }, {
    key: "render",
    value: function render() {
      var _context19, _this$dynamicSection;

      var zoomOptions = {
        minZoom: this.minZoom,
        maxZoom: this.maxZoom,
        zoomScale: this.zoomScale
      };
      var controlsTemplateFn = (0, _bind.default)(_context19 = this.controlsTemplate).call(_context19, this, this.zoom, this.currentPage, this._pages, zoomOptions);
      var controlsTemplate = this._pages.length > 0 ? controlsTemplateFn() : null;
      var pagesTempaltes = this._pages.length > 0 ? this._renderPages(this._pages, this.zoom, this.disableTextLayer) : null;
      return this.html(_templateObject3(), pagesTempaltes, (_this$dynamicSection = this.dynamicSection) === null || _this$dynamicSection === void 0 ? void 0 : _this$dynamicSection.call(this, this.html), controlsTemplate);
    }
  }, {
    key: "_renderPages",
    value: function _renderPages(pages, zoom, disableTextLayer) {
      var _this6 = this;

      return (0, _repeatInstanceProperty(_element))(pages, function (page) {
        return page;
      }, function (page) {
        return _this6.pageTemplate(page, zoom, disableTextLayer);
      });
    }
  }]);
  return PDFRenderer;
}(_element.BlueElement);

exports.PDFRenderer = PDFRenderer;

var registerPDFRenderer = function registerPDFRenderer() {
  (0, _pdfRendererControls.registerPDFRendererControls)();
  (0, _pdfRendererPage.registerPDFRendererPage)();
  (0, _element.register)(PDFRenderer);
};

exports.registerPDFRenderer = registerPDFRenderer;
